/**
 * Carica un'immagine in memoria e la restituisce come `HTMLImageElement`.
 * Necessario per comporre preview multi-layer su canvas offscreen.
 */
export const loadImageElement = (src: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()

    image.crossOrigin = 'anonymous'
    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error(`Impossibile caricare l'immagine ${src}`))
    image.src = src
  })
}

/**
 * Disegna un'immagine dentro un box mantenendo il rapporto (`contain`) e
 * restituisce il rettangolo realmente occupato.
 *
 * Serve per sovrapporre correttamente overlay e base con proporzioni coerenti.
 */
export const drawImageContain = (
  ctx: CanvasRenderingContext2D,
  image: CanvasImageSource,
  x: number,
  y: number,
  width: number,
  height: number
) => {
  const sourceWidth = image instanceof HTMLImageElement ? image.naturalWidth || image.width : width
  const sourceHeight =
    image instanceof HTMLImageElement ? image.naturalHeight || image.height : height

  if (!sourceWidth || !sourceHeight) {
    ctx.drawImage(image, x, y, width, height)
    return { x, y, width, height }
  }

  const scale = Math.min(width / sourceWidth, height / sourceHeight)
  const drawWidth = sourceWidth * scale
  const drawHeight = sourceHeight * scale
  const offsetX = x + (width - drawWidth) / 2
  const offsetY = y + (height - drawHeight) / 2

  ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight)

  return {
    x: offsetX,
    y: offsetY,
    width: drawWidth,
    height: drawHeight,
  }
}
